<template>
  <v-card class="candidate opportunity popup" slot="popup" flat width="250px">
    <div style="height: 2rem;">
      <div class="text-xs-center logo--overlap">
        <v-avatar
          :size="$vuetify.breakpoint.mdAndUp ? 82 : 52"
          :color="themes.candidate.light.muted"
        >
          <v-avatar color="white" :size="$vuetify.breakpoint.mdAndUp ? 80 : 50">
            <v-img
              :src="
                opportunity.organization.logo || '/img/missing/logos/organizations/original.png'
              "
              contain
            />
          </v-avatar>
        </v-avatar>
      </div>
    </div>

    <v-card-title class="text-xs-center pa-0">
      <div style="margin: auto;">
        <a
          @click="newTab(`/opportunities/${opportunity.id}`)"
          style="cursor: pointer; text-decoration: inherit; color: inherit;"
          class="title"
        >
          {{ opportunity.name }}
        </a>
        <div class="pt-1">
          <a
            :href="`/organizations/${opportunity.organization.id}`"
            style="cursor: pointer; text-decoration: inherit; color: inherit;"
            :class="themes.candidate.light.mutedText"
          >
            {{ opportunity.organization.name }}
          </a>
        </div>
      </div>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-layout row wrap align-center justify-space-around>
        <div class="px-1">
          <v-chip
            :textColor="themes.candidate.light[opportunityDateColor]"
            class="transparent"
            outline
          >
            <v-icon
              :color="themes.candidate.light[opportunityDateColor]"
              class="text-vertical-middle"
              left
            >
              mdi-calendar
            </v-icon>
            <span v-if="isOpportunityOpen">
              Closes in <strong>{{ timeToClosingDate }} </strong>
            </span>
            <span v-else-if="willOpportunityOpen">
              Opens in <strong>{{ timeToOpeningDate }} </strong>
            </span>
            <span v-else-if="isOpportunityClosed">Applications closed</span>
          </v-chip>
        </div>
      </v-layout>
    </v-card-text>

    <v-divider />
    <v-card-actions class="px-0 py-1">
      <v-layout row justify-between align-center>
        <v-btn
          v-if="canApply"
          color="success"
          @click.stop="$emit('apply')"
          block
        >
          <span class="font-weight-light">
            {{ opportunity.type == 'event' ? 'RSVP' : 'Apply' }}
          </span>
        </v-btn>
        <v-btn
          v-else
          @click="newTab(`/opportunities/${opportunity.id}`)"
          :color="themes.candidate.light.successButton"
          block
          flat
        >
          <span class="font-weight-light">View</span>
        </v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
// Mixins
import { OpportunityDates } from '@/mixins/OpportunityDates.js'

export default {
  mixins: [OpportunityDates],

  props: { opportunity: { type: Object, required: true } },

  data() {
    return {
      expand: false,
    }
  },

  computed: {
    canApply() {
      return this.isOpportunityOpen || this.willOpportunityOpen
    },
  },

  methods: {
    newTab(uri) {
      if (!uri) return

      window.open(uri, '_blank')
    },
  },
}
</script>

<style lang="scss">
.candidate.opportunity.popup {
  .logo--overlap {
    position: absolute;
    transform: translate(-50%, -70%);
    left: 50%;
  }
}
</style>
